import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=close%20up%20of%20a%20glowing%20paper%20lantern%20with%20warm%20light%20and%20floating%20dust%2C%20dark%20cozy%20background%2C%20small%20round%20holes%20glowing%20softly%20in%20the%20air%2C%20amber%20and%20moss%20green%20palette%2C%20nostalgic%20magical%20illustration%2C%20mysterious%20and%20warm&width=1400&height=500&seq=cta-banner-2026&orientation=landscape"
          alt="洞洞杂货铺暖光纸灯笼"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>
        <div className="relative flex w-full flex-col items-center gap-6 px-6 py-16 text-center md:px-16 md:py-20">
          <h2 className="max-w-2xl text-2xl leading-relaxed text-background-50 md:text-3xl">
            准备好走进这家神秘的小店了吗？
          </h2>
          <p className="max-w-xl text-base leading-relaxed text-background-100/90">
            从世界观到“洞洞”含义，一站读懂《洞洞杂货铺》的完整设定逻辑，开启你的温柔入坑之旅。
          </p>
          <Link
            to="/lore"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            开始阅读设定
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}